module.exports = __webpack_public_path__ + "static/media/Photo3.01f42062.jpg";